import {IOrganizationAdvertiserLogin} from "../interfaces/IOrganizationAdvertiserLogin";

export const initialOrganizationObj: IOrganizationAdvertiserLogin = {
    name:"",
    advertiserLogin:{},
    organization: "",
}